export const PAYMENT_TYPE_CARD = 'card'
export const PAYMENT_TYPE_IBAN = 'sepa_debit'
